import { useAtomValue } from "jotai";

import useUserActivity from "../../api/api-hooks/userActivity/useUserActivity";
import useWorkspace from "../../api/api-hooks/workspaces/useWorkspace";
import AppHelmet from "../../components/AppComponents/AppHelmet";
import UserActivityItem from "../userActivity/UserActivityItem";
import { tenantIDAtom } from "../../atoms/GlobalAtoms";
import AppSpinner from "../../elements/AppSpinner";

const WorkspaceActivity = () => {
  const tenantID = useAtomValue(tenantIDAtom);
  const { userActivity, userActivityLoading } = useUserActivity();
  const { workspace, workspaceLoading } = useWorkspace();

  if (workspaceLoading || userActivityLoading || !tenantID)
    return (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <AppSpinner size="xl" style={{ fontSize: 20, width: 40, height: 40 }} />
      </div>
    );

  const workspaceActivities =
    userActivity?.WorkspacesActivities?.[workspace?.id!];

  return (
    <>
      <AppHelmet title="Home - GrowthCloud.com" />
      <div className="px-2 px-sm-4 py-3">
        <div className="d-flex flex-wrap ">
          <div
            className="mx-2 my-2  rounded p-2 btn-oauth"
            style={{
              flexGrow: 1,
              flexBasis: 350,
              height: "fit-content",
            }}
          >
            <div className="d-flex align-items-center justify-content-between flex-wrap px-2 px-sm-5 py-2">
              <h2 className=" mb-0 text-dark">Recent Activity</h2>
            </div>
            <hr className="my-2 mx-4" />
            {!userActivity && (
              <div className="p-4 d-flex align-items-center ">
                <div style={{ fontSize: 60, lineHeight: 1 }} className="mr-3">
                  &#128552;
                </div>
                <span>
                  <span className="font-weight-600">
                    No activity has been recorded yet.
                  </span>
                  <br />
                  <span className="font-weight-500">
                    We&apos;ll keep track of the pages and views you work in
                    from now on!
                  </span>
                </span>
              </div>
            )}
            {userActivityLoading ? (
              <AppSpinner />
            ) : (
              userActivity && (
                <UserActivityItem
                  workspaceID={workspace?.id!}
                  workspaceActivities={workspaceActivities}
                />
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkspaceActivity;
